"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const InversifySugar_1 = __importDefault(require("./InversifySugar"));
const messagesMap_1 = __importDefault(require("./messagesMap"));
const createExportedProviderRef_1 = __importDefault(require("./createExportedProviderRef"));
const processImports_1 = __importDefault(require("./processImports"));
const constants_1 = require("./constants");
const bindProviderToContainer_1 = require("./binding/bindProviderToContainer");
const getModuleMetadata_1 = require("./metadata/getModuleMetadata");
function importModule(Module, isRoot = false) {
    const metadata = (0, getModuleMetadata_1.getModuleMetadata)(Module);
    const exportedProviders = [];
    if (metadata.isModule) {
        if (isRoot) {
            importRootModule(Module);
        }
        else {
            exportedProviders.push(...importChildModule(Module));
        }
    }
    else {
        console.warn(messagesMap_1.default.notAModuleImported(Module.name));
    }
    return exportedProviders;
}
exports.default = importModule;
/**
 * @description This function is used to import a root module.
 * @param Module
 * @returns
 */
function importRootModule(Module) {
    const metadata = (0, getModuleMetadata_1.getModuleMetadata)(Module);
    if (!metadata.isBinded) {
        for (const provider of metadata.providers.concat(...metadata.globalProviders)) {
            (0, bindProviderToContainer_1.bindProviderToContainer)(provider, InversifySugar_1.default.globalContainer);
        }
        InversifySugar_1.default.onModuleBinded(metadata.container, metadata, Module);
        (0, processImports_1.default)(Module, metadata.imports);
        Reflect.defineMetadata(constants_1.MODULE_IS_BINDED_KEY, true, Module.prototype);
    }
}
/**
 * @description This function is used to import a child module.
 * @param Module
 */
function importChildModule(Module) {
    const metadata = (0, getModuleMetadata_1.getModuleMetadata)(Module);
    const exportedProviderRefs = [];
    if (!metadata.isBinded) {
        (0, processImports_1.default)(Module, metadata.imports);
        for (const provider of metadata.providers) {
            metadata.container.bindProvider(provider);
        }
        for (const provider of metadata.globalProviders) {
            (0, bindProviderToContainer_1.bindProviderToContainer)(provider, InversifySugar_1.default.globalContainer);
        }
        InversifySugar_1.default.onModuleBinded(metadata.container, metadata, Module);
        Reflect.defineMetadata(constants_1.MODULE_IS_BINDED_KEY, true, Module.prototype);
    }
    for (const exportedProvider of metadata.exports) {
        exportedProviderRefs.push(...(0, createExportedProviderRef_1.default)(Module, exportedProvider));
    }
    return exportedProviderRefs;
}
